import Seo from '../components/Seo';
import { breadcrumb, contactPage } from '../lib/seo-schemas';
import MapEmbed from '../components/MapEmbed';
import { waLink } from '../lib/contact';

const WA_VISITANOS = waLink('Hola Bar Cabrero! Una pregunta. Gracias!');

const HORARIO = [
  { dia: 'Lunes',     hora: '11:00–16:00 · 19:00–23:00' },
  { dia: 'Martes',    hora: 'Cerrado', cerrado: true },
  { dia: 'Miércoles', hora: '11:00–16:00 · 19:00–23:00' },
  { dia: 'Jueves',    hora: '11:00–16:00 · 19:00–23:00' },
  { dia: 'Viernes',   hora: '11:00–16:00 · 19:00–24:00' },
  { dia: 'Sábado',    hora: '11:00–16:00 · 19:00–24:00' },
  { dia: 'Domingo',   hora: '11:30–16:00' },
];

export default function Visitanos() {
  return (
    <>
      <Seo
        title="Visítanos — C. Julián Ceballos 19, Torrelavega"
        description="Visita Bar Cabrero en C. Julián Ceballos 19, 39300 Torrelavega (Cantabria). Horarios, mapa y teléfono +34 654 23 34 07. Sin reservas — la barra es de quien llega antes."
        path="/visitanos"
        schemas={[
          breadcrumb([{ name: 'Visítanos', path: '/visitanos' }]),
          contactPage({
            description: 'Dirección, horarios, teléfono y cómo llegar al Bar Cabrero en Torrelavega.',
            path: '/visitanos',
          }),
        ]}
      />

      <section className="sec sec-surf" data-testid="visitanos-page">
        <p className="eyebrow rv">Visítanos</p>
        <h1 className="D D-xl rv" style={{ marginBottom: '1rem' }}>Ven a <em>vernos.</em></h1>
        <p className="lead rv">
          En el corazón de Torrelavega, a un paso de la plaza. Te esperamos en la barra más alta de Cantabria. <strong>Sin reservas — la barra es de quien llega antes.</strong>
        </p>
      </section>

      <section className="sec" data-testid="visitanos-grid">
        <div className="vgrid">
          {/* MAPA */}
          <div className="map-wrap rv">
            <MapEmbed />
          </div>

          {/* INFO */}
          <div className="rv">
            <p className="eyebrow">Datos prácticos</p>
            <h2 className="D D-md" style={{ marginBottom: '1.5rem' }}>Bar <em>Cabrero.</em></h2>

            <div className="icards">
              <div className="icard">
                <p className="icard-l">Dirección</p>
                <p className="icard-v">C. Julián Ceballos 19</p>
                <p className="icard-v" style={{ color: 'var(--muted)', fontWeight: 400 }}>39300 Torrelavega · Cantabria</p>
              </div>
              <div className="icard">
                <p className="icard-l">Teléfono</p>
                <a href="tel:+34654233407" className="icard-v" style={{ textDecoration: 'none', color: 'var(--ink)' }} data-testid="phone-link">+34 654 23 34 07</a>
              </div>
              <div className="icard">
                <p className="icard-l">Instagram</p>
                <a href="https://instagram.com/cabrerobar" target="_blank" rel="noopener noreferrer" className="icard-v" style={{ textDecoration: 'none', color: 'var(--ink)' }}>@cabrerobar</a>
              </div>
              <div className="icard">
                <p className="icard-l">Año</p>
                <p className="icard-v">Desde 1928</p>
              </div>
            </div>

            <p className="eyebrow" id="horario" style={{ marginTop: '0.5rem' }}>Horario</p>
            <table className="htable">
              <tbody>
                {HORARIO.map((h) => (
                  <tr key={h.dia} data-testid={`horario-${h.dia.toLowerCase()}`}>
                    <td className="hday">{h.dia}</td>
                    <td className={`htime ${h.cerrado ? 'hclosed' : ''}`}>{h.hora}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <a className="wa-btn" href={WA_VISITANOS} target="_blank" rel="noopener noreferrer" data-testid="visitanos-whatsapp">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347" />
              </svg>
              Saludar por WhatsApp
            </a>

            <a
              className="btn btn-o"
              href="https://www.google.com/maps/search/Bar+Cabrero+Torrelavega"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-maps-link"
              style={{ width: '100%', justifyContent: 'center', marginBottom: '0.9rem' }}
            >
              Abrir en Google Maps
            </a>

            <div className="terraza">
              <strong>Terraza disponible</strong>
              En los meses de buen tiempo, nuestra terraza es uno de los mejores rincones del centro de Torrelavega para tomarse una gilda al sol.
            </div>
          </div>
        </div>
      </section>

      {/* SIN RESERVAS — explanation */}
      <section className="sec sec-surf" data-testid="visitanos-no-booking">
        <div style={{ maxWidth: '640px', margin: '0 auto', textAlign: 'center' }}>
          <p className="eyebrow rv">Filosofía</p>
          <h2 className="D D-md rv" style={{ marginBottom: '1rem' }}>
            Aquí no hay <em>reservas.</em>
          </h2>
          <p className="lead rv" style={{ marginBottom: '1rem' }}>
            La barra es de quien llega antes. Una caña, una gilda, un saludo. Como ha sido siempre desde 1928.
          </p>
          <p className="copy rv">
            ¿Algo que preguntar? Mándanos un WhatsApp y te respondemos en cuanto haya una pausa en la barra.
          </p>
        </div>
      </section>
    </>
  );
}
